import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Select } from '@ngxs/store';
import {
	AnalyticsEvent,
	AnalyticsService,
} from '@services/analytics/analytics.service';
import {
	MatterMortgageDispatch,
	MatterMortgagesState,
} from '@state/matter/matter_mortgages';
import { Observable } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';

@UntilDestroy()
@Component({
	selector: 'app-editing-mortgage-reline-dialog',
	templateUrl: './editing-mortgage-reline-dialog.component.html',
	standalone: false,
})
export class EditingMortgageReLineDialogComponent implements OnInit {
	public height: string;
	public mortgageId: string;
	public tagValue: string;
	public tagLabel: string;
	public mortgageReLine: string;

	@Select(MatterMortgagesState.getMortgageReLine)
	mortgageReLine$: Observable<string>;

	constructor(
		private mortgageDispatch: MatterMortgageDispatch,
		@Inject(MAT_DIALOG_DATA)
		public data: { mortgageId: string; tagValue: string },
		private dialogRef: MatDialogRef<EditingMortgageReLineDialogComponent>,
		private analytics: AnalyticsService,
	) {
		this.mortgageId = data.mortgageId;
		this.tagValue = data.tagValue;
		this.tagLabel = 'Mortgage ReLine';
		this.height = '8rem';
	}

	ngOnInit(): void {
		this.mortgageReLine$
			.pipe(
				untilDestroyed(this),
				distinctUntilChanged((prev, curr) => prev === curr),
			)
			.subscribe((mortgageReLine) => {
				this.mortgageReLine = mortgageReLine;
				this.tagValue = this.mortgageReLine;
			});
	}

	closeModal(): void {
		this.dialogRef.close();
	}

	onChange($event: string): void {
		this.tagValue = $event;
	}

	save(): void {
		this.mortgageDispatch.SetMortgageReline(this.mortgageId, this.tagValue);
		this.analytics.logEvent(
			AnalyticsEvent.CONDENSED_EDITOR_MATTER_MORTGAGE_RELINES_SAVE_CLICK,
		);
		this.closeModal();
	}

	reset(): void {
		this.mortgageDispatch.ResetMortgageReline(this.mortgageId);
		this.analytics.logEvent(
			AnalyticsEvent.CONDENSED_EDITOR_MATTER_MORTGAGE_RELINES_RESET_CLICK,
		);
		this.tagValue = this.mortgageReLine;
	}
}
